import React, {Component} from 'react';
import "./style.less";
const image1 = require('../../../common/image/image1.png');
const click = require('../../../common/image/click.png');
const image3 = require('../../../common/image/image3.png');
const image4 = require('../../../common/image/image4.png');
const image5 = require('../../../common/image/image5.png');
export default class Security extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render(){
        return(
            <div className="princeActive">
                <div className="content">
                    <div className="part1">
                        <div className="bg">
                            <div className="imgbg">
                                <img src={image1} onClick={()=>{window.location.href='http://www.supowercar.com/driverprince-api/app/version/sweepCode/trainee/android'} }/>
                                <img className="click" src={click} />
                            </div>
                           <div className="word1">
                                <span>免费送你回家（活动规则）</span>
                                <div>1.只要在学车小王子APP报名并缴费380元学车报名费，即可获得乘车券，免费乘车一次。</div>
                                <div>2.在民途出行平台乘车时，针对没有驾照或者帮别人报名，选择在学车小王子APP上缴纳380元学车报名费，就可以领取免费乘车券一张。</div>
                           </div>
                           <div className="word2">
                                <span>使用规则</span>
                                <div>1.学车小王子APP报名学车有效期三年内，免费乘车券有效期六个月内免费乘坐一次。</div>
                                <div>2.免费乘车券不限定学车本人使用，全省通用，仅使用一次。</div>
                                <div>3.乘车券不支持多人使用，仅供一人使用。</div>
                                <div>详细咨询（客服号码:19995943497）</div>
                           </div>
                        </div>
                    </div>
                    <div className="part2">
                        <img src={image3} />
                    </div>
                    <div className="part3">
                        <img src={image4} />
                    </div>
                    <div className="part4">
                        <img src={image5} />
                    </div>
                </div>

            </div>



        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/PrinceActive/index.js